import type {HTMLChakraProps} from '@chakra-ui/react';
import {forwardRef, useEditableContext} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';

import {useEditableFieldsStyleConfig} from '../../theme-config';
import {EditableCancelButton, EditableSubmitButton} from '../EditableFields';

export const EditableOnControls = forwardRef<HTMLChakraProps<'div'>, 'div'>((props, ref) => {
  const {children, ...rest} = props;
  const {isEditing} = useEditableContext();
  const styles = useEditableFieldsStyleConfig(props);

  return isEditing ? (
    <ChakraDiv __css={styles.controlsOn} {...rest} ref={ref}>
      {children || (
        <>
          <EditableCancelButton />
          <EditableSubmitButton />
        </>
      )}
    </ChakraDiv>
  ) : null;
});
